import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EventService } from "./event.service";
import { IAlert } from "app/modules/admin/apps/file-manager/file-manager.types";
import { Util } from "app/models/util";
import { AlertMessageService } from "./alert.message.service";

@Injectable({ providedIn: "root" })
export class ServiceProvider {
	constructor(
		public router: Router,
 		public http: HttpClient,
		 public util: Util,
		 private _alertService: AlertMessageService,
		 public eventService: EventService
		
		
	) {}

	// public logout() {
	// 	this.eventService.logoutEvent.emit();
	// }

	public accessDenied(message: string) {
		// this.util.dismissAllModals();
		//this.util.navigateToDashboard();
		this.showAlert("error", message);
	}

	public showError(message: string) {
		try {
			if (message != null) message = message.replace("java.lang.RuntimeException:", "");
			if (message != null) message = message.replace("java.lang.IllegalArgumentException:", "");
		} catch (error) {}

		this.showAlert("error", message); // don't self close error messages
	}

	public showErrorSelfClose(message: string) {
		this.showAlert("error", message);
	}

	public showMessage(message: string) {
		this.showAlert("error", message);
	}

	private showAlert(type: string, message: string, selfClose: boolean = true) {
		const alert: IAlert = {
              type,
		      message,
			  selfClose,
		};
		this._alertService.apply(alert);
	  }

	public getAddOnQueryParam() {
		if (window.location.href.indexOf("source=addon") != -1) return "?source=addon";
		return "";
	}
}
